<template>
    <div class="remind_add">
        <van-form @submit="onSubmit">
            <div class="remind_add-label">提醒内容</div>
            <van-field
                v-model="dataForm.reminderContent"
                rows="3"
                maxlength="50"
                autosize
                type="textarea"
                placeholder="简单描述下您的提醒内容"
                :border="false"
                class="gary-input"
                show-word-limit
                :rules="[{ required: true }]"
            />
            <div class="remind_add-label">提醒时间</div>
            <van-field 
                class="gary-input" 
                v-model="dataForm.reminderTime" 
                readonly 
                right-icon="arrow" 
                placeholder="请设置您的每日提醒时间" 
                @click="selectTime" 
                :rules="[{ required: true }]"
            />
            <foot-button>
                <van-button v-if='detailId' style="width:30vw"  plain native-type="button" type="primary"  @click="deleteRemind"> 删除 </van-button>
                <van-button  :disabled="canSubmit" native-type="submit" type="primary" block > 确认 </van-button>
            </foot-button>
        </van-form>
        <van-popup v-model="show" position="bottom">
            <van-datetime-picker
                ref="date"
                v-model="currentDate"
                title="选择时间"
                type="time"
                @confirm="handleConfirm"
                @cancel="show = false"
            />
        </van-popup>
        
    </div>
</template>
<script>
export default{
    name:'remain-add',
    data(){
        return{
            dataForm:{
                reminderTime:'',
                reminderContent:''
            },
            show:false,
            currentDate: '00:00',
        }
    },
    computed:{
        info () {
				return this.$store.getters['account/patientInfo']
		},
        detailId(){
            return  this.$route.params.id
        },
        canSubmit(){
            const {reminderTime,reminderContent} = this.dataForm
            return !reminderTime||!reminderContent
        }
    },
    created(){
        if(this.detailId){
            this.getDetail()
        }
    },
    methods:{
        getDetail(){
            this.$api.patient.getRemindDetail(this.detailId).then(({data})=>{
                this.dataForm = data
            })
        },
        selectTime(){
            this.show = true
        },
        handleConfirm(time){
            this.show = false
            this.dataForm.reminderTime = time
        },
        onSubmit(){
            let func = this.$api.patient.addRemind
            if(this.detailId){
                func = this.$api.patient.updateRemind
            }
            func({
                    ...this.dataForm,
                    patientId:this.$store.getters['account/getPatientId'] ,
                    patientName:this.info.name
            }).then(({code})=>{
                if(code === 0){
                    this.$toast.success({
                        message:'保存成功',
                        forbidClick:true,
                        onClose:()=>{
                            this.$router.go(-1)
                        }
                    })
                  
                }
            })
        },
        deleteRemind(){
            this.$dialog.alert({
                title: '提示',
                message: '确定要删除此提醒吗',
                showCancelButton:true,
                confirmButtonText:'删除'
            }).then(() => {
            // on close
                this.$api.patient.deleteRemind(this.detailId).then(({code})=>{
                    if(code === 0){
                        this.$toast.success({
                        message:'删除成功',
                        forbidClick:true,
                        onClose:()=>{
                            this.$router.go(-1)
                        }
                    })
                    }
                })
            });

        }
    }
}
</script>
<style lang='less' scoped>
.remind_add{
    background-color: #ffffff;
    min-height: calc(100vh - 40px);
    padding: 40px 40px 0 40px;
    &-label{
       font-size: 32px;
       line-height: 36px;
       color: #1F2329; 
       font-weight: 600;
       margin-bottom: 28px;
    }
    .gary-input{
        border-radius: 12px;
        background-color:#F5F6F7 ;
        margin-bottom: 40px;
        font-size: 28px;
    }
}
</style>